import {
  AMODULO_ADMAPPCLI,
  AMODULO_CRM,
  AMODULO_ESTOQUE,
  AMODULO_FINANCAS,
  AMODULO_FRONT,
  AMODULO_FROTAS,
  AMODULO_GERENCIAL,
  AMODULO_PARTNER,
  AMODULO_SISAREPASSENGER,
} from 'consts';
import api from 'services/api';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

/* Encerra a sessão do usuário na API */
const Logout = props => {
  const { history } = props;

  useEffect(() => {
    async function executarLogout() {
      const modulo = sessionStorage.getItem('modulo');
      const partnerPortal = sessionStorage.getItem('partnerPortal');

      try {
        await api.post('/logout');
      } catch (error) {
        console.error('Erro ao encerrar a sessão na API:', error);
      } finally {
        sessionStorage.removeItem('sisare_access_token');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('usuario');
        sessionStorage.removeItem('codUser');
        sessionStorage.removeItem('lastLogin');
        sessionStorage.removeItem('isTechnicalUser');
        sessionStorage.removeItem('codModulo');
        sessionStorage.removeItem('mesComboProd');
        sessionStorage.removeItem('anoComboProd');
        sessionStorage.removeItem('moeda');
        sessionStorage.removeItem('trabOutraMoeda');
        sessionStorage.removeItem('formaPDV');
        sessionStorage.removeItem('codEmpresa');
        sessionStorage.removeItem('mod-ger-tipoExtraFat');
        sessionStorage.removeItem('fantasia');
        sessionStorage.removeItem('modulo');
        sessionStorage.removeItem('localizador');
        sessionStorage.removeItem('codOS');
        sessionStorage.removeItem('exportaLayoutA2x');
        sessionStorage.removeItem('nomePax');
        sessionStorage.removeItem('exportaContabil');
        sessionStorage.removeItem('identEmpCtbPeloSetor');
        sessionStorage.removeItem('trabProgramacaoSugestivo');
        sessionStorage.removeItem('trabHsServDiaEspec');
        sessionStorage.removeItem('trabTipoPadraoServico');
        sessionStorage.removeItem('codPDV');
        sessionStorage.removeItem('idPartner');
        sessionStorage.removeItem('emailPartner');
        sessionStorage.removeItem('usuarioPartner');
        sessionStorage.removeItem('partnerPortal');
        sessionStorage.removeItem('pdv');
        sessionStorage.removeItem('empresa');
        sessionStorage.removeItem('cfg');
        sessionStorage.removeItem('cfg_financas');
        sessionStorage.removeItem('cfg_crm');
        sessionStorage.removeItem('dicionarioDadosFornecedor');

        switch (parseInt(modulo, 10)) {
          case AMODULO_FRONT:
            history.replace('/front');
            break;
          case AMODULO_FINANCAS:
            history.replace('/financas');
            break;
          case AMODULO_GERENCIAL:
            history.replace('/gerencial');
            break;
          case AMODULO_ESTOQUE:
            history.replace('/estoque');
            break;
          case AMODULO_CRM:
            history.replace('/crm');
            break;
          case AMODULO_SISAREPASSENGER:
            history.replace('/appcli');
            break;
          case AMODULO_ADMAPPCLI:
            history.replace('/admappcli');
            break;
          case AMODULO_FROTAS:
            history.replace('/frotas');
            break;
          case AMODULO_PARTNER:
            history.replace(partnerPortal === 'partner' ? '/partner' : '/admpartner');
            break;
          default:
            history.replace('/login');
            break;
        };
      }
    };

    executarLogout();
  }, [history]);

  return null;
};

Logout.propTypes = {
  history: PropTypes.object.isRequired
};

export default withRouter(Logout);